import * as Label from "@radix-ui/react-label"
import * as RadixSwitch from "@radix-ui/react-switch"

import { cn } from "@/domains/library"

type LabelPosition = "left" | "right"

export const SwitchTiny = ({
  className,
  classNameLabel,
  onCheckedChange,
  checked,
  id,
  label,
  labelPosition = "left",
}: {
  className?: string
  classNameLabel?: string
  onCheckedChange: (checked: boolean) => void
  checked: boolean
  id: string
  label: string
  labelPosition?: LabelPosition
}) => {
  return (
    <div className="flex items-center gap-1">
      {labelPosition === "left" && label !== "" ? (
        <Label.Root className={cn("labelRootTiny text-xs font-bold text-t200", classNameLabel)} htmlFor={id}>
          {label}
        </Label.Root>
      ) : null}
      <RadixSwitch.Root
        className={cn("switchRootTiny", className)}
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
      >
        <RadixSwitch.Thumb className="switchThumbTiny" />
      </RadixSwitch.Root>
      {labelPosition === "right" && label !== "" ? (
        <Label.Root className={cn("labelRootTiny text-xs font-bold text-t200", classNameLabel)} htmlFor={id}>
          {label}
        </Label.Root>
      ) : null}
    </div>
  )
}

export default SwitchTiny
